/**
 * Facebook Pixel helper functions for conversion tracking
 * Documentation: https://www.facebook.com/business/help/402791146561655
 */

/**
 * Track a standard or custom event with Facebook Pixel
 * @param {string} eventName - The name of the event (e.g., 'Contact', 'Lead', 'SubmitApplication')
 * @param {object} params - Optional parameters for the event
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

/**
 * Track contact form submission
 */
export const trackContact = () => {
  trackEvent('Contact');
};

/**
 * Track lead generation (form submission)
 */
export const trackLead = () => {
  trackEvent('Lead');
};

/**
 * Track WhatsApp contact
 */
export const trackWhatsAppContact = () => {
  trackEvent('Contact', { contact_method: 'WhatsApp' });
};

/**
 * Track phone contact
 */
export const trackPhoneContact = () => {
  trackEvent('Contact', { contact_method: 'Phone' });
};

/**
 * Google Analytics helper functions
 * Uses gtag.js for event tracking
 */

/**
 * Track a custom event with Google Analytics
 * @param {string} eventName - The name of the event
 * @param {object} params - Event parameters
 */
export const trackGAEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

/**
 * Track rental car reservation click (Reservar button to Amovens)
 * @param {string} carTitle - The title/name of the car
 * @param {string} carSlug - The slug identifier of the car
 * @param {string} amovensUrl - The destination Amovens URL
 */
export const trackRentalCarReservation = (carTitle, carSlug, amovensUrl) => {
  // Track with Google Analytics
  trackGAEvent('rental_car_reservation_click', {
    event_category: 'Rental Cars',
    event_label: carTitle,
    car_name: carTitle,
    car_slug: carSlug,
    destination_url: amovensUrl,
    transport_type: 'external_link'
  });

  // Also track with Facebook Pixel
  trackEvent('Lead', {
    content_name: carTitle,
    content_category: 'Rental Car Reservation',
    content_ids: [carSlug]
  });
};
